<template>
  <div>
    <div class="container_filtro">
      <div class="form-group">
        <label for="exampleFormControlTextarea2">Filtrar Atendimentos</label>
        <select class="form-control input i-width" @change="onChangeStatus" required>
          <option value="all">Todos</option>
          <option value="pending" selected>Pendente</option>
          <option value="in_progress">Em tratamento</option>
          <option value="resolved">Resolvido</option>
        </select>
      </div>
    </div>
    <card title="Atendimentos aberto pelo site" subTitle="Atendimentos pendentes">
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID</th>
            <th>ID Cliente</th>
            <th>Protocolo</th>
            <th>Nome</th>
            <th>CPF</th>
            <th>Status</th>
            <th>Ações</th>
          </thead>
          <tbody>
            <tr v-for="internalAffair in internalAffairs" :key="internalAffair.id">
              <td>{{ internalAffair.id }}</td>
              <td>{{ internalAffair.clientId }}</td>
              <td>{{ internalAffair.protocol }}</td>
              <td>{{ internalAffair.name }}</td>
              <td>{{ internalAffair.cpf }}</td>
              <td>{{ { pending: 'Pendente', in_progress: 'Em andamento', resolved: 'Resolvido' }[internalAffair.status] }}</td>
              <td>
                <router-link :to="`/atendimento/${internalAffair.id}/visualizar`">
                  <p-button type="info" outline icon title="Visualizar Atendimento">
                    <i class="fa fa-eye"></i>
                  </p-button>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
    <Pagination
      :currentPage="pagination.currentPage"
      :totalPages="pagination.totalPages"
      v-on:update="updatePagination"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  components: { Pagination },
  computed: {
    internalAffairs() {
      return this.$store.getters.internalAffairs;
    },
    pagination() {
      return this.$store.getters.internalAffairPagination;
    },
  },
  data() {
    return {
      status: 'pending',
    };
  },
  methods: {
    ...mapActions(["fetchInternalAffairs", "resolveInternalAffair"]),
    async updatePagination({ currentPage }) {
      await this.fetchInternalAffairs({
        currentPage,
        status: this.status,
      });
    },
    async onChangeStatus(e) {
      this.status = e.target.value !== 'all' ? e.target.value : undefined;
      await this.fetchInternalAffairs({
        currentPage: 1,
        status: this.status,
      });
    },
  },
  async mounted() {
    try {
      await this.fetchInternalAffairs({
        currentPage: 1,
        status: this.status,
      });
    } catch (err) {
      await Swal.fire("Ops!", "Não foi possível carregar os dados", "error");
    }
  }
};
</script>

<style scoped>
input {
  padding: 5px;
  width: 15rem;
}
button.btn-search {
  border: none;
  border: 1px solid;
  background: #9DCF6B;
  padding: 6px;
}
</style>
